import { useCallback, useEffect, useRef, useState } from 'react'
import type { ListRef } from 'rc-virtual-list'

interface UseListHeightReturn {
  listRef: React.RefObject<ListRef>
  listHeight: number
}

/**
 * 가상 리스트의 동적 높이 계산 훅
 * 윈도우 크기 변경 및 데이터 변경 시 리스트 높이를 자동으로 계산
 * @param {Array} todoRenderDataList - 렌더링할 데이터 리스트
 * @returns {Object} 리스트 ref와 계산된 높이
 */
export const useListHeight = (todoRenderDataList: any[]): UseListHeightReturn => {
  const [listHeight, setListHeight] = useState<number>(480)
  const listRef = useRef<ListRef>(null)

  const getListHeight = useCallback(() => {
    if (listRef.current) {
      const parentRect = listRef.current.nativeElement.parentElement.getBoundingClientRect()
      const rect = listRef.current.nativeElement.getBoundingClientRect()
      // Mobile 에서는 Bottom Toolbar 가 추가되어 Window 계산시 가려지는 현상으로 parent를 이용해 수정.
      const height = parentRect.top + parentRect.height - rect.top
      setListHeight(height)
    }
  }, [])

  // 윈도우 리사이즈 이벤트 리스너 등록
  useEffect(() => {
    getListHeight()
    window.addEventListener('resize', getListHeight)
    return () => {
      window.removeEventListener('resize', getListHeight)
    }
  }, [getListHeight])

  // 데이터 변경 시 즉시 높이 재계산 (디바운스 없이)
  useEffect(() => {
    getListHeight()
  }, [todoRenderDataList, getListHeight])

  return {
    listRef,
    listHeight,
  }
}
